import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.038 25.975a7.103 7.103 0 0 0 7.092 6.72h3.53l1.417 1.602a62.016 62.016 0 0 0 7.6 7.244l1.17.939a3.045 3.045 0 0 0 4.937-2.095c.4-4.34.598-9.608.598-15.807 0-6.202-.199-11.472-.598-15.813a3.044 3.044 0 0 0-4.935-2.096l-1.118.896a61.435 61.435 0 0 0-7.505 7.134l-1.565 1.76h-3.53a7.103 7.103 0 0 0-7.093 6.72 25.906 25.906 0 0 0 0 2.796Zm28.685 8.804c.39.404 1.032.415 1.435.026A14.165 14.165 0 0 0 37.5 24.582c0-3.944-1.616-7.632-4.418-10.296a1.015 1.015 0 1 0-1.398 1.47 12.136 12.136 0 0 1 3.787 8.826c0 3.35-1.359 6.482-3.722 8.763a1.015 1.015 0 0 0-.026 1.434ZM13.147 18.49H10.13a5.074 5.074 0 0 0-5.066 4.8 23.873 23.873 0 0 0 0 2.577 5.074 5.074 0 0 0 5.066 4.8h3.017V18.489Zm2.03-.68v13.538l1.42 1.604a59.997 59.997 0 0 0 7.35 7.008l1.17.939a1.015 1.015 0 0 0 1.646-.699c.393-4.271.59-9.48.59-15.621 0-6.144-.197-11.354-.59-15.627a1.015 1.015 0 0 0-1.645-.699L24 9.148a59.41 59.41 0 0 0-7.257 6.899l-1.566 1.763Z",
    fill: "currentColor"
  }));
};

var SvgSoundLow = styled(SvgComponent).withConfig({
  displayName: "SoundLow__SvgSoundLow",
  componentId: "sc-wtpqir-0"
})(["", " ", ""], size, color);
export default SvgSoundLow;